<template>
    <div id="repot">
        <a-row type="flex" justify="start">
            <a-col>
                <a-input :placeholder="$t('publicLang.PleaseEnter')" style="width: 200px;" size="small" v-model="TopformVal.reportName" @pressEnter="searchReportTable"/>
            </a-col>
            <a-col style="margin: 0 4px">
                <a-select :placeholder="$t('publicLang.PleaseSelect')" style="width: 200px" size="small" v-model="TopformVal.reportType">
                    <a-select-option value="UDR">UDR</a-select-option>
                    <a-select-option value="IRP">IRP</a-select-option>
                </a-select>
            </a-col>
            <a-col>
                <a-select placeholder="Status" style="width: 200px" size="small" v-model="TopformVal.status">
                    <a-select-option value="New">New</a-select-option>
                    <a-select-option value="Issued">Issued</a-select-option>
                    <a-select-option value="Inactive">Inactive</a-select-option>
                </a-select>
            </a-col>
            <a-col style="margin-left: 4px" @click="searchReportTable">
                <a-button type="primary" >{{ $t('publicLang.Search') }}</a-button>
            </a-col>
        </a-row>
        <a-divider style="margin: 10px 0" dashed/>
        <a-row type="flex" justify="space-between">
            <a-col>
                <a-tooltip placement="topLeft">
                    <template slot="title">
                        <span>{{ $t('generic.Add') }}</span>
                    </template>
                    <img @click="addReport" class="sbxs" src="../../assets/img/ss-add.png" width="22" height="22">
                </a-tooltip>
<!--                <a-popconfirm-->
<!--                        :title="$t('generic.AreyoudeleTask')"-->
<!--                        @confirm="cancelReport"-->
<!--                        :okText="$t('generic.Yes')"-->
<!--                        :cancelText="$t('generic.No')"-->
<!--                >-->
                    <a-tooltip placement="topLeft">
                        <template slot="title">
                            <span>{{ $t('publicLang.Cancel') }}</span>
                        </template>
                        <img style="margin:0 4px" class="sbxs" src="../../assets/img/ss-delete.png"  @click="cancelReport"   width="22" height="22">
                    </a-tooltip>
<!--                </a-popconfirm>-->
                <a-tooltip placement="topLeft">
                    <template slot="title">
                        <span>Refresh</span>
                    </template>
                    <img class="sbxs ml4"  src="../../assets/img/ss-refresh.png" width="20" height="20" @click="refersh">
                </a-tooltip>
                <a-tooltip placement="topLeft">
                    <template slot="title">
                        <span>{{ $t('reportSetting.CopyFromMaster') }}</span>
                    </template>
                    <a-button shape="circle" type="primary" size="small" style="margin-left: 4px" icon="copy" @click="copyFromMaster"></a-button>
                </a-tooltip>
                <a-tooltip placement="topLeft">
                    <template slot="title">
                        <span>{{ $t('generic.Publish') }}</span>
                    </template>
                    <a-button @click="publishSubmit" shape="circle" type="primary" size="small" style="margin-left: 4px;text-align: center;" v-if="Role != 'ORG_ADMIN'">
                        <i class="iconfont" style="font-size: 14px;margin: 0 auto;" >&#xe6a4;</i>
                    </a-button>
                </a-tooltip>


                <a-tooltip placement="topLeft">
                    <template slot="title">
                        <span>{{synBtnName}}</span>
                    </template>
                    <a-button @click="sendToPro"   type="primary" size="small" style="margin-left: 4px;text-align: center;" >
                        <a-icon type="save"/>
                        <span>{{synBtnName}}</span>
                    </a-button>
                </a-tooltip>



            </a-col>
            <a-col>
                <a-pagination
                        :pageSizeOptions="page.pageSizeOptions"
                        :showTotal="total => `${$t('generic.totalOf')} ${page.pagingTotal} ${$t('generic.Records')}`"
                        size="small"
                        :total="page.pagingTotal"
                        v-model="page.currentVal"
                        :pageSize.sync="page.pagingSize"
                        @change="tableChangePage"
                        @showSizeChange="onShowSizeChange"
                        showSizeChanger
                />
            </a-col>
        </a-row>
        <a-row style="margin-top: 10px;height: 78vh;" class="mt">
            <vxe-table
                    border
                    resizable
                    highlight-hover-row
                    :data="tableData"
                    @cell-dblclick="dbcellClickEvent"
                    height="auto"
                    size="mini"
                    ref="reportTableF">
                <template v-slot:empty>
                    <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                </template>
                <vxe-table-column type="checkbox" width="35"></vxe-table-column>
                <vxe-table-column field="reportName" :title="$t('roleGe.ReportName')" show-header-overflow="ellipsis" show-overflow="ellipsis" minWidth="150"></vxe-table-column>
                <vxe-table-column field="reportType" :title="$t('reportSetting.ReportType')" show-header-overflow="ellipsis" show-overflow="ellipsis"  minWidth="150"></vxe-table-column>
                <vxe-table-column field="status" :title="$t('generic.Status')"  show-header-overflow="ellipsis" show-overflow="ellipsis"  minWidth="150"></vxe-table-column>
                <vxe-table-column field="isPaging" :title="$t('generic.IsPaging')"  show-header-overflow="ellipsis" show-overflow="ellipsis"  minWidth="150"></vxe-table-column>
                <vxe-table-column field="devName" :title="$t('reportSetting.DevName')" show-header-overflow="ellipsis" show-overflow="ellipsis"  minWidth="150"></vxe-table-column>
                <vxe-table-column field="createTime" :title="$t('generic.CreateDate')" show-header-overflow="ellipsis" show-overflow="ellipsis"  minWidth="150"></vxe-table-column>
                <vxe-table-column field="modifier" :title="$t('generic.Modifier')" show-header-overflow="ellipsis" show-overflow="ellipsis"  minWidth="150"></vxe-table-column>
                <vxe-table-column field="modifyTime" :title="$t('generic.ModifyDate')" show-header-overflow="ellipsis" show-overflow="ellipsis"  minWidth="150"></vxe-table-column>
                <vxe-table-column field="isPrintReport" :title="$t('reportSetting.isPrintReport')"  show-header-overflow="ellipsis" show-overflow="ellipsis"  minWidth="150"></vxe-table-column>
                <vxe-table-column field="printReportCode" :title="$t('reportSetting.printReportCode')" show-header-overflow="ellipsis" show-overflow="ellipsis"  minWidth="150"></vxe-table-column>
            </vxe-table>
        </a-row>
        <!--add-->
        <a-modal
                :title="$t('roleGe.ReportSetting')"
                :visible="addVisible"
                width="50%"
                @cancel="handleCancel">
            <template slot="footer">
                <a-button type="primary" size="small" @click="saveAddSubmit">{{ $t('publicLang.Save') }}</a-button>
            </template>
            <a-form :form="Addform" v-bind="formItemLayout" >

                <a-form-item label="Report Code" v-bind="formItemLayout" >
                    <a-input
                            size="small"
                            :placeholder="$t('publicLang.PleaseEnter')"
                            v-decorator="
                        [
                            'reportCode',
                        { rules: [{ required: true, message: $t('publicLang.Required')}]
                        }]"/>
                </a-form-item>

                <a-form-item :label="$t('roleGe.ReportName')" v-bind="formItemLayout" >
                    <a-input
                            size="small"
                            :placeholder="$t('publicLang.PleaseEnter')"
                            v-decorator="
                        [
                            'reportName',
                        { rules: [{ required: true, message: $t('publicLang.Required')}]
                        }]"/>
                </a-form-item>
                <a-form-item :label="$t('reportSetting.ReportType')" v-bind="formItemLayout" >
                    <a-select  size="small"  v-decorator="['reportType',{rules: [{ required: true, message: $t('publicLang.Required')}]}]" :placeholder="$t('publicLang.PleaseSelect')" @change="reportTypeChange">
                        <a-select-option value="UDR">User Define Report</a-select-option>
                        <a-select-option value="IRP">iReport</a-select-option>
                    </a-select>
                </a-form-item>


                <a-form-item :label="$t('reportSetting.DevName')" v-bind="formItemLayout" >
                    <a-input
                            size="small"
                            :placeholder="$t('publicLang.PleaseEnter')"
                            v-decorator="
                        [
                            'devName',
                        { rules: [{ required: true, message: $t('publicLang.Required')}]
                        }]"/>
                </a-form-item>



                <a-form-item :label="$t('generic.IsPaging')" v-bind="formItemLayout"  >
                    <a-switch :disabled="!isPaging" size="small" v-decorator="['isPaging', { valuePropName: 'checked' }]"/>
                </a-form-item>

                <a-form-item label="Is Auto Print" v-bind="formItemLayout" v-if="!isPaging">
                    <a-switch  size="small" v-decorator="['isAutoPrint', { valuePropName: 'checked', initialValue: false }]"/>
                </a-form-item>

                <a-form-item label="Export Excel (Raw Data)" v-bind="formItemLayout" v-if="!isPaging">
                    <a-switch  size="small" v-decorator="['isExcel', { valuePropName: 'checked' }]"/>
                </a-form-item>
                <a-form-item label="Export Excel (with Layout)" v-bind="formItemLayout" v-if="!isPaging">
                    <a-switch  size="small" v-decorator="['exportExcelWithLayout', { valuePropName: 'checked' }]"/>
                </a-form-item>
                <a-form-item label="Is Auto Load" v-bind="formItemLayout">
                    <a-switch  size="small" v-decorator="['isAutoLoad', { valuePropName: 'checked' }]"/>
                </a-form-item>
            </a-form>
        </a-modal>
        <!--edit-->
        <a-drawer
                :title="$t('roleGe.ReportSetting')"
                placement="right"
                width="90%"
                @close="onCloseEdit"
                :visible="EditVisible">
            <a-tabs defaultActiveKey="0" tabPosition="left" @change="menuClickGetData">
                <a-tab-pane tab="Basic" key="0"><r-header v-on:initTable="getInitTable" :currentRow="currentRow" :headerUid="headerUid" :key="comKey"></r-header></a-tab-pane>
                <a-tab-pane tab="Organization" key="1"><org :headerUid="headerUid" :key="comKey"></org></a-tab-pane>
                <a-tab-pane tab="Project" key="3"><project :headerUid="headerUid" :key="comKey"></project></a-tab-pane>
                <a-tab-pane tab="User" key="9" ><user-coms :headerUid="headerUid" :key="comKey"></user-coms></a-tab-pane>
                <!--                <a-tab-pane tab="Data Source" key="2" v-if="Role == 'SYSTEM_ADMIN'"><data-sorce :headerUid="headerUid" :key="comKey"></data-sorce></a-tab-pane>-->
                <a-tab-pane tab="Data Source" key="2"><data-sorce :headerUid="headerUid" :key="comKey"></data-sorce></a-tab-pane>
                <a-tab-pane tab="Manager" key="7" v-if="currentRow.reportType != 'UDR'"><manager :headerUid="headerUid" :key="comKey"></manager></a-tab-pane>
                <a-tab-pane tab="PrintConfig" key="8" v-if="currentRow.reportType != 'UDR'"><printConfig :headerUid="headerUid" :key="comKey"></printConfig></a-tab-pane>
                <a-tab-pane tab="Template" key="4" v-if="currentRow.reportType != 'IRP'"><template-coms :headerUid="headerUid" :key="comKey"></template-coms></a-tab-pane>
                <!--<a-tab-pane tab="Project" key="5" v-if="Role == 'ORG_ADMIN'">-->
                <!--<project :headerUid="headerUid" :key="comKey"></project></a-tab-pane>-->
                <!--<a-tab-pane tab="User" key="6" v-if="Role == 'ORG_ADMIN'">-->
                <!--<user-coms :headerUid="headerUid" :key="comKey"></user-coms>-->
                <!--</a-tab-pane>-->
                <!--<a-tab-pane tab="Where Clause" key="7"><where-clause :headerUid="headerUid"></where-clause></a-tab-pane>-->
                <!--<a-tab-pane tab="Column" key="3">-->
                <!--<column :headerUid="headerUid" :key="comKey"></column>-->
                <!--</a-tab-pane>-->
                <a-tab-pane tab="Schedule "  key="Schedule">
                    <schedule-coms :currentRow="currentRow"></schedule-coms>
                </a-tab-pane>
            </a-tabs>
        </a-drawer>
        <!--copy search-->
        <a-modal
                title="Copy Search"
                :visible="CopySearchVis"
                @cancel="copyhandleCancel"
                width="85%"
        >
            <template slot="footer">
                <a-button type="primary" size='small' @click="saveCopySearch">Save</a-button>
            </template>
            <a-row type="flex" justify="space-between" style="margin-bottom: 6px;">
                <a-col>
                    <a-row type="flex" justify="start">
                        <a-col>
                            <a-input :placeholder="$t('publicLang.PleaseEnter')" style="width: 120px;" size="small"  v-model="copyPage.copyReportName"/>
                        </a-col>
                        <a-col style="margin-left: 4px">
                            <a-button type="primary" size="small" @click="getCopyTable">{{ $t('publicLang.Search') }}</a-button>
                        </a-col>
                    </a-row>
                </a-col>
                <a-col>
                    <a-pagination
                            :pageSizeOptions="copyPage.pageSizeOptions"
                            :showTotal="total => `Total ${copyPage.pagingTotal}  Records`"
                            size="small"
                            :total="copyPage.pagingTotal"
                            v-model="copyPage.currentVal"
                            :pageSize.sync="copyPage.pagingSize"
                            @change="copyTableChangePage"
                            @showSizeChange="copyOnShowSizeChange"
                            showSizeChanger
                    />
                </a-col>
            </a-row>
            <vxe-table
                    border
                    resizable
                    highlight-hover-row
                    :data="copyTableData"
                    size="small"
                    ref="copySearchTbale">
                <template v-slot:empty>
                    <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                </template>
                <vxe-table-column type="checkbox" width="35"></vxe-table-column>
                <vxe-table-column field="reportName" :label="$t('roleGe.ReportName')" show-header-overflow="ellipsis" show-overflow="ellipsis" minWidth="150"></vxe-table-column>
                <vxe-table-column field="reportType" :label="$t('reportSetting.ReportType')" show-header-overflow="ellipsis" show-overflow="ellipsis"  minWidth="150"></vxe-table-column>
                <vxe-table-column field="version" :label="$t('reportSetting.Version')"  show-header-overflow="ellipsis" show-overflow="ellipsis"  minWidth="150"></vxe-table-column>
                <vxe-table-column field="status" :label="$t('generic.Status')"  show-header-overflow="ellipsis" show-overflow="ellipsis"  minWidth="150"></vxe-table-column>
                <vxe-table-column field="isPaging" :label="$t('generic.IsPaging')"  show-header-overflow="ellipsis" show-overflow="ellipsis"  minWidth="150"></vxe-table-column>
                <vxe-table-column field="devName" :label="$t('reportSetting.DevName')"  show-header-overflow="ellipsis" show-overflow="ellipsis"  minWidth="150"></vxe-table-column>
                <vxe-table-column field="exportExcelWithLayout" label="Export Excel (with Layout)"  show-header-overflow="ellipsis" show-overflow="ellipsis"  minWidth="150"></vxe-table-column>
                <!--<vxe-table-column field="createTime" :label="$t('roleGe.Creator')" show-header-overflow="ellipsis" show-overflow="ellipsis"  minWidth="150"></vxe-table-column>-->
                <vxe-table-column field="createTime" :label="$t('generic.CreateDate')" show-header-overflow="ellipsis" show-overflow="ellipsis"  minWidth="150"></vxe-table-column>
                <vxe-table-column field="modifier" :label="$t('generic.Modifier')" show-header-overflow="ellipsis" show-overflow="ellipsis"  minWidth="150"></vxe-table-column>
                <vxe-table-column field="modifyTime" :label="$t('generic.ModifyDate')" show-header-overflow="ellipsis" show-overflow="ellipsis"  minWidth="150"></vxe-table-column>
            </vxe-table>
        </a-modal>
    </div>
</template>
<script>
    import org from './reportCom/org.vue'
    import dataSorce from './reportCom/dataSorce.vue'
    import manager from './reportCom/manager.vue'
    import printConfig from './reportCom/printConfig.vue'
    import column from './reportCom/DS/column.vue'
    import templateComs from './reportCom/template.vue'
    import project from './reportCom/project.vue'
    import userComs from './reportCom/user.vue'
    import whereClause from './reportCom/whereClause.vue'
    import rHeader from './reportCom/header.vue'
    import scheduleComs from './reportCom/scheduleComs.vue'


    import ajax from '../../api/ajax'
    import api from '../../api/url'
    import { mapState } from "vuex";
    import cookie from '../../api/cookie'

    export default{
        computed: {
            ...mapState(["Role"])
        },
        components:{
            org,
            dataSorce,
            column,
            templateComs,
            project,
            userComs,
            whereClause,
            rHeader,
            manager,
            printConfig,
            scheduleComs
        },
        data(){
            return{
                synBtnName: ajax.ajaxUrl().indexOf("prod") > -1 ? "Send Uat" : "Send Prod" ,
                comKey: 0,
                isPaging: false, // ReportType宣布在是否分页
                page:{
                    pageSizeOptions: ['10', '20', '30', '40','100','200','500','1000'],
                    pagingTotal: 10,
                    currentVal: 1,
                    pagingSize:  Number.parseInt(sessionStorage.getItem('pageSize') || '30')
                }, // 分页
                TopformVal:{
                    reportName: null,
                    reportType: undefined,
                    status: undefined
                },
                tableData: [],  // 表格数据
                Addform: this.$form.createForm(this),
                addVisible: false, // add flag
                formItemLayout: {
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 8 }
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 16 }
                    }
                },
                EditVisible: false,
                headerUid: '',
                currentRow: {},
                menuKey: 0,
//                copy Search
                CopySearchVis: false,
                copyTableData: [],
                copyPage:{
                    pageSizeOptions: ['10', '20', '30', '40','100','200','500','1000'],
                    pagingTotal: 10,
                    currentVal: 1,
                    pagingSize:  Number.parseInt(sessionStorage.getItem('pageSize') || '30'),
                    copyReportName: null
                }
//                copy serch end
            }
        },
        created(){
            this.init()
        },
        methods:{
            sendToPro(){
                let arr = []
                let v = this.$refs.reportTableF.getCheckboxRecords()
                if (v.length  == 0){
                    this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'));
                    return ;
                }else if (v.length > 1){
                    this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'));
                    return ;
                }
                for(let i in v){
                    arr.push(v[i].uid)
                }

                let paramsData = [];
                for (let index in arr) {
                    if (arr[index].uid != "") {
                        let paramsObj = {};
                        paramsObj.key = "uid";
                        paramsObj.value = arr[index];
                        paramsData.push(paramsObj);
                    }
                }
                ajax.post(api.REPORTRREPORT, {params:paramsData}).then(res=>{
                    if(res.code == 200){
                        this.$message.success(res.msg);
                        this.copyPage.copyReportName = null
                        this.CopySearchVis = false
                        this.init()
                    }else{
                        this.$customMessage.warning(res.msg);
                    }
                })
            },
            refersh(){
                this.init()
            },
            reportTypeChange(val){
                if(val == 'IRP'){
                    this.isPaging = false
                }else{
                    this.isPaging = true
                }
                this.Addform.setFieldsValue({ ['isPaging']: this.isPaging })
            },
            menuClickGetData(val){
                this.comKey ++
            },
//            copy search
            copyFromMaster(){
                this.CopySearchVis = true
                this.getCopyTable()
            },
            saveCopySearch(){
                let v = this.$refs.copySearchTbale.getCheckboxRecords()
                if(v.length > 0){
                    ajax.post(api.REPORTGENERICCONFIGCOPY,{masterList: v}).then(res=>{
                        if(res.code == 200){
                            this.$message.success(res.msg);
                            this.copyPage.copyReportName = null
                            this.CopySearchVis = false
                            this.init()
                        }else{
                            this.$customMessage.warning(res.msg);
                        }
                    })
                }else{
                    this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'));
                    return
                }
            },
            getCopyTable(){
                let params = {
                    pageNum: this.copyPage.currentVal,
                    pageSize: this.copyPage.pagingSize,
                    reportName: this.copyPage.copyReportName
                }
                ajax.get(api.REPORTGENERICCONFIGCOPY,params).then(res=>{
                    this.copyTableData = res.data.table
                })
            },
            copyhandleCancel(){
                this.CopySearchVis = false
            },
            copyTableChangePage(current){
                this.copyPage.currentVal = current;
                this.getCopyTable();
            },
            copyOnShowSizeChange(current, pageSize){
                this.copyPage.currentVal = current;
                this.copyPage.pagingSize = pageSize;
                this.getCopyTable();
            },
//          copy search end
//            发布
            publishSubmit(){
                let arr = []
                let v = this.$refs.reportTableF.getCheckboxRecords()
                if(v.length > 0){
                    for(let i in v){
                        arr.push(v[i].uid)
                    }
                }else{
                    this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'));
                    return
                }
                ajax.post(api.REPORTGENERICPUBLISH,{uids: arr}).then(res=>{
                    if(res.code == 200){
                        this.$message.success(res.msg);
                        this.init()
                    }else{
                        this.$customMessage.warning(res.msg);
                    }
                })
            },
            getInitTable(type){
                if(type != 'init'){
                    this.currentRow.reportType = type
                }else{
                    this.init()
                }

            },
            init(){
                let params = {
                    pageNum: this.page.currentVal,
                    pageSize: this.page.pagingSize,
                    reportName: this.TopformVal.reportName,
                    reportType: this.TopformVal.reportType,
                    status: this.TopformVal.status
                }
                ajax.get(api.REPORTGENERICCONFIGTABLE,params).then(res=>{
                    this.page.pagingTotal = res.data.total
                    this.tableData = res.data.table
                })
            },
//            分页
            tableChangePage(current) {
                this.page.currentVal = current;
                this.init();
            },
            //      选择条数
            onShowSizeChange(current, pageSize) {
                this.page.currentVal = current;
                this.page.pagingSize = pageSize;
                this.init();
            },
//            搜索
            searchReportTable(){
                this.page.currentVal = 1
                this.init()
            },
//            add Report start
//            取消
            handleCancel(){
                this.addVisible = false
            },
//            添加report
            addReport(){
                this.addVisible = true
                this.Addform.resetFields();
            },
            saveAddSubmit(){
                this.Addform.validateFields((err, values) => {
                    if (!err) {
                        values.isPaging = values.isPaging ? '1' : '0'
                        values.isAutoPrint = values.isAutoPrint ? '1' : '0'
                        values.isExcel = values.isExcel ? '1' : '0'
                        values.isAutoLoad = values.isAutoLoad ? '1' : '0'
                        values.exportExcelWithLayout = values.exportExcelWithLayout?'1':'0'
                        ajax.post(api.REPORTGENERICCONFIGTABLE,values).then(res=>{
                            if(res.code == 200){
                                this.$message.success(res.msg);
                                this.addVisible = false
                                this.init()
                            }else{
                                this.$customMessage.warning(res.msg);
                            }

                        })
                    }
                });
            },
//            add Report end
//          cancel
            cancelReport(){
            let arr = []
            let v = this.$refs.reportTableF.getCheckboxRecords()
            if(v.length > 0){
              for(let i in v){
                arr.push(v[i].uid)
              }
            }else{
              this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'));
              return
            }
            let params = {
              uids: arr
            }

            let that = this;
            this.$customConfirm({
              title: that.$t('pubGicSet.AreyoudeleTask'),
              okText: that.$t('publicLang.Confirm'),
              cancelText: that.$t('publicLang.Cancel'),
              content: "",
              onOk() {
                ajax.post(api.REPORTGENERICCONFIGTABLEDELETION,params).then(res=>{
                  if(res.code == 200){
                    that.$message.success(res.msg);
                    that.init()
                  }
                })
              }
            });
          },

            onCloseEdit(){
                this.EditVisible = false
                this.init()
            },
//            双击编辑
            dbcellClickEvent({ row }) {

                this.headerUid = row.uid
                this.currentRow = row
                this.currentRow.isPaging  = this.currentRow.isPaging == 'false' ? false : true
                this.currentRow.isExcel = this.currentRow.isExcel == 'false' ? false : true
                this.currentRow.isAutoPrint = this.currentRow.isAutoPrint == 'false' ? false : true
                this.currentRow.isAutoLoad = this.currentRow.isAutoLoad == 'false' ? false : true
                this.currentRow.exportExcelWithLayout = this.currentRow.exportExcelWithLayout == 'false' ? false : true
                this.currentRow.isPrintReport = this.currentRow.isPrintReport == 'false' ? false : true
                this.EditVisible = true
            },
        }
    }
</script>
<style>
    #repot{
        background: #fff;
        padding: 10px;
    }
</style>